/* eslint-disable */
export default {
  rateExceeded:
    'Limite de solicitações excedido. O aplicativo continuará em {ttl} segundos.',
} as const;

// @key: @#@"rateExceeded"@#@ @source: @#@"Request limit exceeded. App will resume in {ttl} seconds."@#@
